import { From, To } from '../Responsive';
import { CloudinaryImage } from '../../components/CloudinaryImage';

/**
 * Renders a mobile or desktop image depending on the current screen size.
 * This component does not make any assumptions about how the image should be
 * styled and instead accepts an object of classNames to apply to the
 * component.
 *
 * @param {object} props - The props!
 * @param {object} props.classNames - The classNames to apply to the component.
 * @param {string} props.classNames.container - The class name to apply to the
 *   container that wraps the image.
 * @param {string} props.classNames.desktopImage - The class name to apply to
 *   the desktop image.
 * @param {string} props.classNames.mobileImage - The class name to apply to the
 *   mobile image.
 * @param {object} props.images - The mobile and desktop images to render.
 * @param {object} props.images.desktopImage - The desktop image to render.
 * @param {object} props.images.mobileImage - The mobile image to render.
 * @returns {JSX.Element}
 */
export function ResponsiveImage({ classNames, images, ...rest }) {
  if (!images.desktopImage || !images.mobileImage) return null;

  return (
    <div className={classNames.container}>
      <From slice={3}>
        <CloudinaryImage
          {...images.desktopImage}
          className={classNames.desktopImage}
          {...rest}
        />
      </From>
      <To slice={2}>
        <CloudinaryImage
          {...images.mobileImage}
          className={classNames.mobileImage}
          {...rest}
        />
      </To>
    </div>
  );
}
